var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-block"},[_c('div',{staticClass:"introduction"},[_c('div',{staticClass:"sunbeam-abc"},[_c('div',{staticClass:"logo-ABC"},[_c('img',{staticClass:"img-logo",attrs:{"src":require("../assets/SunBEAm_logo.png")}})]),_c('div',{staticClass:"sunbeam-abc-description"},[_vm._v(" Analysis & Bioinformatics Center (ABC) ")])])])])
}]

export { render, staticRenderFns }